<template>
  <v-card>
    <v-card-title>{{ cardTitle }}</v-card-title>
    <v-card-text>
      <p v-if="action === 'delete'" class="title ml-3">Are you sure?</p>
      <v-form v-else ref="form" v-model="valid" lazy-validation>
        <v-checkbox
          v-model="formData['wasPreviouslyDeclaredToCbc']"
          label="Was invoice previously declared with CBC?"
          hint="Please make sure to check this box if the invoice was already declared with customs on a previous shipment to avoid paying the duty again."
          persistent-hint
          :error-messages="formErrors['wasPreviouslyDeclaredToCbc']"
          class="cbc-checkbox"
        >
        <template v-slot:prepend>
          <img src="../../assets/information.png" alt="Custom Icon" style="width: 24px; height: 24px;" />
        </template>
      </v-checkbox>
        <v-divider class="ma-5"></v-divider>
        <v-file-input
          v-if="
            !selectedPackage.invoice || selectedPackage.invoice.invoiceFiles.length === 0
          "
					multiple
					counter
					show-size
          v-model="computedInvoiceFiles"
          label="Invoice Files(Up to 5 Files)"
          :error-messages="formErrors['invoiceFilesInput']"
          :required="true"
        >
					<template #selection="{ index, text }">
						<v-chip small label close color="primary" @click:close="removeInvoiceFile(index)">{{ text }}</v-chip>
					</template>
        </v-file-input>
        <div v-else class="mb-5">
          <p class="mt-1 mb-0 subtitle-1" v-for="file of selectedPackage.invoice.invoiceFiles" :key="file.id">
            <v-icon class="mr-2">mdi-attachment</v-icon>
            <a  :href="file.file" target="_blank"
              >Attached Invoice</a
            >
          </p>
        </div>
        <v-text-field
          v-model="formData['amount']"
          type="number"
          id="amount"
          label="Total Cost"
          name="amount"
          prepend-icon="mdi-currency-usd"
          :error-messages="formErrors['amount'] ? 'Only numerical characters allowed' : ''"
          :required="true"
        ></v-text-field>
        <v-text-field
          v-model="formData['description']"
          id="description"
          label="Description"
          name="description"
          prepend-icon="mdi-card-text-outline"
          :error-messages="formErrors['description']"
          :required="false"
        ></v-text-field>
      </v-form>

      <v-alert v-if="formErrors.nonFieldErrors" type="error" text dense>
        {{ formErrors.nonFieldErrors[0] }}
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn text @click="closeDialog">Cancel</v-btn>
      <v-btn
        text
        :color="action === 'delete' ? 'error' : 'success'"
        @click="submitForm"
        :loading="isWaitingForResponse"
        >{{ action === "delete" ? "delete" : "save" }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  name: 'InvoiceForm',

  components: {
  },

  props: {
    selectedPackage: Object,
    action: {
      type: String,
      required: true,
      validator: function (value) {
        return ['create', 'edit', 'delete'].includes(value)
      }
    },
  },

  data: () => ({
    isWaitingForResponse: false,
    valid: true,
    invoiceFiles: [],
    newInvoiceFile: null,
    formData: {},
    formErrors: {},
  }),

  mounted: function () {
    if (this.action === "edit") {
      this.formData = this.selectedPackage.invoice
    }
    if (this.action !== "delete") {
      this.resetValidation()
    }
  },

  computed: {
		computedInvoiceFiles: {
			get() {
				return this.invoiceFiles
			},
			set(v) {
				console.log(v)
				this.invoiceFiles = [
					...this.invoiceFiles,
					...v,
				].filter( (item, ind, arr) => 
					arr.findIndex((f) => f.path === item.path && item.size === f.size) === ind)

			},
		},
    cardTitle: function () {
      const cardTitles = {
        "create": "Upload Invoice(s)",
        "edit": "Edit Invoice",
        "delete": "Delete Invoice",
      }
      return cardTitles[this.action]
    }
  },

  methods: {
		removeInvoiceFile(index) {
			this.invoiceFiles.splice(index, 1)
		},
		addFiles(files) {
			console.log("Files", files, this.invoicefiles)
			this.invoiceFiles = [...this.invoiceFiles, ...files].filter(
				(item, ind, arr) => arr.findIndex((f) => f.path === item.path && item.size === f.size) === ind)
		},
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getFormData() {
      const formData = new FormData()
      if (this.invoiceFiles) {
				this.invoiceFiles.slice(0, 4).forEach(file => {
					formData.append("invoiceFilesInput", file)
				})
      }
      if (this.newInvoiceFile) {
        formData.append("invoiceFile", this.newInvoiceFile)
      }
      formData.append("package", this.selectedPackage.id)
      formData.append("description", this.formData["description"] || "")
      formData.append("amount", this.formData["amount"] || "")
      formData.append(
        "wasPreviouslyDeclaredToCbc",
        this.formData["wasPreviouslyDeclaredToCbc"] || false
      )
      return formData
    },
    submitForm: function () {
      const submitMethods = {
        "create": this.createRecord,
        "edit": this.editRecord,
        "delete": this.deleteRecord
      }
      this.isWaitingForResponse = true
      submitMethods[this.action]()
    },
    createRecord: function () {
      axios
        .post(
          `${process.env.VUE_APP_API_ROOT_URL}invoices/`,
          this.getFormData()
        )
        .then(() => {
          this.isWaitingForResponse = false
          this.updateData()
          this.closeDialog()
        })
        .catch(error => {
          this.formErrors = error.response.data
          this.isWaitingForResponse = false
        });
    },
    editRecord: function () {
      const invoiceId = this.selectedPackage.invoice.id
      axios
        .patch(
          `${process.env.VUE_APP_API_ROOT_URL}invoices/${invoiceId}/`,
          this.getFormData()
        )
        .then(() => {
          this.isWaitingForResponse = false
          this.updateData()
          this.closeDialog()
        })
        .catch(error => {
          this.formErrors = error.response.data
          this.isWaitingForResponse = false
        });
    },
    updateData: function () {
      this.$emit('update-data')
    },
    closeDialog: function () {
      this.$emit('close-dialog')
    },
  },
};
</script>
<style>
.cbc-checkbox label.v-label {
    color: red;
    font-weight: 500;
}
</style>